module.exports = __webpack_public_path__ + "media/images/prevention_form/soziale-medien-e37e46cbf3327945e434e01b9ffc5236.svg";